import { jwtDecode } from "jwt-decode";

export const BASE_API = window.BASE_API || "https://api.voipadda.com/";
export const BASE_WEB_SOCKET = "api.voipadda.com";
export const API_SERVER_URL = window.BASE_API || "https://api.voipadda.com/";
export const BASE_DOMAIN = window.VOIP_HOST || "sip.voipadda.com";
export const VOIP_WS_URL = window.VOIP_WS_URL || `wss://${window.VOIP_HOST || "sip.voipadda.com"}:${window.VOIP_WS_PORT || 8089}/ws`;
export const FILE_BASE_RECORDING = window.FILE_BASE_RECORDING || "https://sip.voipadda.com/";


export const DecryptToken = () => {
  let token = "";
  if (typeof window !== "undefined") {
    token = localStorage.getItem("psx_token") || "";
  }

  let decoded = {};
  if (token && token !== "undefined") {
    try {
      decoded = jwtDecode(token);
    } catch (e) {
      console.error("Invalid token:", e.message);
      localStorage.removeItem("psx_token"); // Clear invalid token
    }
  }
  return decoded;
};

export async function CallGETAPI(url, params = "", headers = {}) {
  try {
    let token = localStorage.getItem("psx_token");
    let AllHeaders = { ...headers };
    if (token) {
      AllHeaders = { Authorization: "Bearer " + token, ...headers };
    }
    let res = await fetch(BASE_API + url + params, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...AllHeaders,
      },
    });

    if (res.status === 403) {
      localStorage.removeItem("psx_token");
      window.location.href = "/";
      return { status: false, msg: "Unauthorized - Redirecting to login", data: [] };
    }

    if (!res.ok) {
      return { status: false, msg: `Request failed with status ${res.status}`, data: [] };
    }

    let resultData = await res.json();
    return { status: true, msg: "", data: resultData };
  } catch (e) {
    return { status: false, msg: e.message, data: [] };
  }
}

export async function FetchUserExtension(headers = {}) {
  const extensionResponse = await CallGETAPI("api/get-user-extension", "", headers);
  if (extensionResponse.status && extensionResponse.data?.data) {
    return {
      status: true,
      msg: "",
      data: extensionResponse.data.data,
    };
  }

  const userInfoResponse = await CallGETAPI("api/get-user-info", "", headers);
  if (userInfoResponse.status && userInfoResponse.data?.combinedRecords) {
    return {
      status: true,
      msg: "",
      data: userInfoResponse.data.combinedRecords,
    };
  }

  return {
    status: false,
    msg: extensionResponse.msg || userInfoResponse.msg || "User extension not found",
    data: null,
  };
}

export async function CallPOSTAPI(url, params = {}, headers = {}) {
  try {
    let token = localStorage.getItem("psx_token");
    let AllHeaders = { ...headers };
    if (token) {
      AllHeaders = { Authorization: "Bearer " + token, ...headers };
    }

    const isFormData = params instanceof FormData;

    let res = await fetch(BASE_API + url, {
      method: "POST",
      headers: isFormData ? { ...AllHeaders } : { "Content-Type": "application/json", ...AllHeaders },
      body: isFormData ? params : JSON.stringify(params),
    });

    if (res.status === 403) {
      localStorage.removeItem("psx_token");
      window.location.href = "/";
      return { status: false, msg: "Unauthorized - Redirecting to login", data: [] };
    }

    if (!res.ok) {
      return { status: false, msg: `Request failed with status ${res.status}`, data: [] };
    }

    let resultData = await res.json();
    return { status: true, msg: resultData?.msg, data: resultData };
  } catch (e) {
    return { status: false, msg: e.message, data: [] };
  }
}

export async function CallPostFileUpload(url, params, headers = {}) {
  try {
    let token = localStorage.getItem("psx_token");
    let AllHeaders = { ...headers };
    if (token) {
      AllHeaders = { Authorization: "Bearer " + token, ...headers };
    }

    let res = await fetch(BASE_API + url, {
      method: "POST",
      headers: AllHeaders,
      body: params,
    });

    if (res.status === 403) {
      localStorage.removeItem("psx_token");
      window.location.href = "/";
      return { status: false, msg: "Unauthorized - Redirecting to login", data: [] };
    }

    if (!res.ok) {
      return { status: false, msg: `Request failed with status ${res.status}`, data: [] };
    }

    let resultData = await res.json();
    return { status: true, msg: "", data: resultData };
  } catch (e) {
    return { status: false, msg: e.message, data: [] };
  }
}

export async function CallDELETEAPI(url, headers = {}) {
  try {
    let token = localStorage.getItem("psx_token");
    let AllHeaders = { ...headers };
    if (token) {
      AllHeaders = { Authorization: "Bearer " + token, ...headers };
    }

    const response = await fetch(BASE_API + url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        ...AllHeaders,
      },
    });

    if (response.status === 403) {
      localStorage.removeItem("psx_token");
      window.location.href = "/";
      return { status: false, msg: "Unauthorized - Redirecting to login" };
    }

    if (!response.ok) {
      return { status: false, msg: `Request failed with status ${response.status}` };
    }

    return await response.json();
  } catch (error) {
    console.error("Error in DELETE API:", error);
    return { status: false, msg: error.message || "Error in DELETE request" };
  }
}
